module.exports = __webpack_public_path__ + "img/true.e358f382.png";